import React from 'react';
import { Browser } from 'Utils/browserFeatureDetection';
import { UpgradeBrowser } from 'Components/UpgradeBrowser';
// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';
import { render } from './reactOverrides';
import App from './App';

const yiwpAppContainer = document.getElementById('YIWP-app');

if (Browser.isModern) {
  const history = createBrowserHistory();
  const path = (/#!(\/.*)$/.exec(window.location.href) || [])[1];
  if (path) {
    history.replace(path);
  }
  render(<App />, yiwpAppContainer);
} else {
  render(<UpgradeBrowser />, yiwpAppContainer);
}
